<template>
  <div class="experiment mb-15">
    <v-row v-if="current.user_level=='ADMIN'">
      <v-col>
        <v-select
          :items="api.schools"
          :item-text="selectLabel('schools')"
          item-value="school_code"
          v-model="form.school_code"
          :label="selectLabel('label')"
          :disabled="current.user_level!='ADMIN'"
          @change="goTo(form.school_code)"
        ></v-select>
      </v-col>
    </v-row>
    <h4 class="my-5">{{ $t("group_experiment.header") }}</h4>
    <div class='mt-5 mb-2 title d-flex'>

      <span><v-img width="30px" :src='api.school_logo_url' /></span>
      <span v-if="$i18n.locale=='tc'" class='ml-2'> {{ api.school_chname }} </span>
      <span v-else class='ml-2'> {{ api.school_enname }} </span>
      <span class="ml-auto">
        <v-btn color="light-green lighten-3" @click="dialog_calendar = true; componentKey+=1" disabled>
          <v-icon>mdi-calendar</v-icon>
          {{ $t("booking.calendar_btn") }}
        </v-btn>
      </span>
    </div>
    <v-row class="mx-3">
      <v-spacer></v-spacer>      
    </v-row>    
    <router-view @info="schoolInfo" :key="childrenKey" :par="par" ref="mab"></router-view>
  </div>
</template>
<script>

import {api_dds_general} from '@/services/dds/api_dds_general';
const apiDDSGeneral = new api_dds_general(process.env.VUE_APP_BASE_URL);


export default {
  name: "group-experiment-index",
  components: {
  },
  mixins: [],
  data: function () {
    return {
      authorized: false,
      par: "this is pars",
      componentKey: 0,
      childrenKey: 0,
      my_schools: [],
      current:{
        school_code: null,
        username: null,
        user_level: "STUDENT",
        auth_token: null,
        experiment: null,
        equipment_id: null,
      },
      api:{
        schools:[],
        book_slots: [],
        slots: [],
        school_code: null,
        school_enname: null,
        school_chname: null,
        school_name: null,
        school_chi_name: null,
        school_logo_url: "",
        eStatus: "",
        daily_slots: [],
      },      
      form: {
        school: "",
        school_code: "",
        experiment: "",
        equipment_id: "",
        next: "",
      },
    };
  },
  created: function () {
  },
  mounted: function () {    
    var self = this;

    self.init();
  },
  
  methods: {
    init(){
      var self = this;
      self.current.school_code = self.$store.state.user.school_code;
      self.current.username = self.$store.state.user.username;
      self.current.uid = self.$store.state.user.uid;
      self.current.user_level = self.$store.state.user.user_level;
      self.current.auth_token = self.$store.state.user.auth_token;
      if(self.current.user_level != "ADMIN") {    // is student or teacher
        self.form.school_code = self.current.school_code;
        self.getUserAuthSchool();
      }
      else {                                      // is admin
        self.getFullSchoolList();
        if(self.$route.params.school_code == undefined){
          self.form.school_code = self.current.school_code;
          self.$router.push("/group_experiment_board/"+self.current.school_code);
        }
        else {
          self.form.school_code = self.$route.params.school_code;
          //self.$router.push("/booking/"+self.form.school_code);
        }
      }
    },
    selectLabel(label){
      var self = this;
      if(self.$i18n.locale=='tc'){
        if (label=='label') return "請選擇學校ID"
        else if (label=='schools') return "code_chname"
      }
      else {
        if (label=='label') return "Please select a School ID";
        else if (label=='schools') return "code_enname";
      }
    },   
    getFullSchoolList(){
      var self = this;
      apiDDSGeneral.getFullSchoolList()
        .then((response) => {
          self.api.schools = response.schools;
      });
    },
    getUserAuthSchool(){
      var self = this;
      apiDDSGeneral.getUserAuthSchool(self.current.school_code, self.current.username, self.current.uid).then((response) => {
        //if(response.status=="success" && self.$route.params.school_code!=response.school){
        //  self.$router.push("/booking/"+response.school+"/");
        //}
        if(response.schools.length < 1){
          self.$store.commit("showSnackBar", "Fail to retrieve school info. Please try again.");
          self.$router.push("/");
        }
        if(self.$route.params.school_code == undefined){
          self.$router.push("/group_experiment_board/"+response.my_school+"/");
        }
        let hasRight = self.my_schools.find(school => school.school === self.$route.params.school_code);
        if(hasRight == undefined){
          self.$router.push("/group_experiment_board/"+response.my_school+"/");
        }
        
      });
    },
    schoolInfo({school_code, school_enname, school_chname, school_logo_url}){
      var self = this;
      self.api.school_code = school_code;
      self.api.school_enname = school_enname;
      self.api.school_chname = school_chname;
      self.api.school_logo_url = school_logo_url;
      self.selected_school = self.api.school_code;
      
    },    
    goTo(school_code){
      var self = this;
      self.$router.push("/group_experiment_board/"+school_code);
      self.init();      
      self.componentKey+=1;
      self.childrenKey+=1;
    },
  },  
};
</script>